export type ProjectTableViewMode = "list" | "grid" | "listAllOrgs";
// Quick-filter pill state for the Projects table (see ProjectsList).
export type ProjectStatusFilterKey = "all" | "published" | "ready";
export type ProjectTypeFilterKey = "custom" | "autopilot";
export type ProjectType =
  | "new_video"
  | "hey_genius"
  | "newsletter"
  | "templated_project"
  | "flash"
  | "flash_education";
export enum ExperienceLabel {
  Video = "video",
  AnimatedDocument = "animatedDocument",
  Chatbot = "chatBot",
  Audio = "audio",
  Podcast = "podcast",
  Quiz = "quiz",
  TextSummary = "textSummary",
}

export type ExperienceOptions = {
  [key in ExperienceLabel]?: boolean;
};

export enum ReservedProjectTags {
  PAGE_ID = "page_id",
  PRODUCT_SKU = "product_sku",
  WEB_PAGE_URL = "web_page_url",
  HEY_GENIUS_DOC = "hey_genius_doc",
  PROMPT = "prompt",
}
